import { api } from './api';

// ── Daten anfordern: Vorbereiten → Vorschau/Test-Link → Senden (wie bei Signatur-Mails) ──

export interface PreparedDataRequest { token: string; formUrl: string }

export const prepareDataRequest = (
  email: string,
  customerId?: number,
  includeDauerdokumente?: boolean,
) => api.post<PreparedDataRequest>('/api/customer-invitations/prepare', { email, customerId, includeDauerdokumente });

export interface DataRequestEmailPreview {
  defaultSubject: string; defaultAnrede: string; defaultMessage: string; subject: string; html: string;
}

/** Unabhängig von prepare()/einem Token — wie bei den Signatur-Vorschauen, läuft parallel
 *  zum Vorbereiten statt danach. */
export const previewDataRequestEmail = (
  customerId: number | undefined,
  includeDauerdokumente: boolean | undefined,
  body: { subject?: string; anrede?: string; message?: string },
) => api.post<DataRequestEmailPreview>('/api/customer-invitations/preview', { customerId, includeDauerdokumente, ...body });

export const sendPreparedDataRequest = (
  token: string,
  body: { email?: string; subject?: string; anrede?: string; message?: string; cc?: string },
) => api.post<{ ok: boolean }>(`/api/customer-invitations/prepared/${token}/send`, body);

export const discardPreparedDataRequest = (token: string) =>
  api.post<{ ok: boolean }>(`/api/customer-invitations/prepared/${token}/discard`, {});
